import * as React from "react";
import styled from "styled-components";
import { select } from "@hubper/theme";
import Text from "../Text";
import posed from "react-pose";

const Base = styled.div`
  position: absolute;
  border-radius: ${select.radius("normal")};
  background-color: rgba(0, 0, 0, 0.75);
  padding: ${select.space(1)} ${select.space(3)};
  display: flex;
`;

type Props = {
  children: string;
  className?: string;
  style?: React.CSSProperties;
  position?: "top" | "bottom" | "left" | "right";
};

function Tooltip({ children, className, style }: Props, ref: any) {
  return (
    <Base className={className} style={style} ref={ref}>
      <Text style={{ textAlign: "center" }} fs={-2} c="white">
        {children}
      </Text>
    </Base>
  );
}

function calcX(props: Props) {
  const p = props.position;

  if (p === "top" || p === "bottom") {
    return "-50%";
  }

  if (p === "left") {
    return "-100%";
  }

  return "0%";
}

function calcY(props: Props) {
  const p = props.position;

  if (p === "left" || p === "right") {
    return "-50%";
  }
  if (p === "top") {
    return "-100%";
  }

  return "0%";
}

export default posed(React.forwardRef(Tooltip))({
  enter: {
    opacity: 1,
    x: calcX,
    y: calcY,
    scale: 1,
    transition: {
      type: "spring",
      stiffness: 800,
      damping: 40
    }
  },
  exit: {
    opacity: 0,
    x: calcX,
    y: calcY,
    scale: 0.8,
    transition: {
      type: "spring",
      stiffness: 300,
      damping: 30
    }
  }
});
